import $ from "jquery";
// @ts-ignore — GLightbox n'a pas de typings TS officiels embarqués.
import GLightbox from "glightbox";
import "./../styles/main.scss";
import { initCookieBanner } from "./helpers/CookieBanner";
require("./tabs");
require("./projects-map");
$(function () {
    // Bandeau de consentement cookies (RGPD, Consent Mode v2 pour GA4)
    initCookieBanner();
    // ===== Mobile menu toggle =====
    var $body = $("body");
    $(document).on("click", "[data-menu-toggle], .site-header__burger", function (e) {
        e.preventDefault();
        $body.toggleClass("menu-open");
        $(".site-header__nav").toggleClass("is-open");
        var expanded = $body.hasClass("menu-open");
        $(".site-header__burger").attr("aria-expanded", String(expanded));
    });
    $(document).on("click", "[data-menu-close]", function (e) {
        e.preventDefault();
        $body.removeClass("menu-open");
        $(".site-header__nav").removeClass("is-open");
        $(".site-header__burger").attr("aria-expanded", "false");
    });
    // Close mobile menu on outside click
    $(document).on("click", function (e) {
        if ($body.hasClass("menu-open") && !$(e.target).closest(".site-header").length) {
            $body.removeClass("menu-open");
            $(".site-header__nav").removeClass("is-open");
            $(".site-header__burger").attr("aria-expanded", "false");
        }
    });
    // ===== Nav dropdown (hover desktop, click mobile) =====
    $(document).on("click", ".nav-dropdown > .nav-label", function (e) {
        if (window.matchMedia("(max-width: 768px)").matches) {
            e.preventDefault();
            $(this).parent().toggleClass("open").siblings().removeClass("open");
        }
    });
    // ===== Smooth scroll to anchors =====
    $(document).on("click", 'a[href^="#"]:not([href="#"])', function (e) {
        var _a, _b;
        var target = $(this).attr("href");
        if (!target || target === "#")
            return;
        var $t = $(target);
        if ($t.length) {
            e.preventDefault();
            $("html, body").animate({ scrollTop: ((_b = (_a = $t.offset()) === null || _a === void 0 ? void 0 : _a.top) !== null && _b !== void 0 ? _b : 0) - 80 }, 400);
        }
    });
    // ===== Project list view toggle (grid <-> list) =====
    $(document).on("click", "[data-view-toggle]", function (e) {
        e.preventDefault();
        var view = $(this).data("view-toggle");
        $("[data-view-toggle]").removeClass("active");
        $(this).addClass("active");
        $(".projects-results").attr("data-view", view);
        var url = new URL(window.location.href);
        url.searchParams.set("view", view);
        window.history.replaceState({}, "", url.toString());
    });
    // ===== Hero slider (auto-rotation + dots) =====
    $("[data-hero-slider]").each(function () {
        var $root = $(this);
        var $slides = $root.find(".home-hero__slide");
        var $panels = $root.find(".home-hero__panel");
        var $dots = $root.find(".home-hero__dot");
        var count = $slides.length;
        if (count < 2)
            return;
        var interval = parseInt($root.attr("data-autoplay") || "6000", 10);
        var current = 0;
        var timer = null;
        var goTo = function (i) {
            current = ((i % count) + count) % count;
            $slides.removeClass("is-active").eq(current).addClass("is-active");
            $panels.removeClass("is-active").eq(current).addClass("is-active");
            $dots.removeClass("is-active").eq(current).addClass("is-active");
        };
        var next = function () { return goTo(current + 1); };
        var start = function () { stop(); timer = window.setInterval(next, interval); };
        var stop = function () { if (timer) {
            window.clearInterval(timer);
            timer = null;
        } };
        $dots.on("click", function () {
            goTo(parseInt($(this).attr("data-slide-target") || "0", 10));
            start();
        });
        // ----- Swipe : touch (mobile/tablette) + drag souris (desktop).
        // Pointer Events unifie les deux. Seuil 50 px ; on ignore les gestes
        // dominants verticaux pour ne pas bloquer le scroll natif.
        var pointerStartX = 0;
        var pointerStartY = 0;
        var pointerActive = false;
        var SWIPE_THRESHOLD = 50;
        var rootEl = $root[0];
        rootEl.addEventListener("pointerdown", function (e) {
            // Pour la souris : on n'écoute que le bouton gauche.
            if (e.pointerType === "mouse" && e.button !== 0)
                return;
            pointerStartX = e.clientX;
            pointerStartY = e.clientY;
            pointerActive = true;
        });
        rootEl.addEventListener("pointerup", function (e) {
            if (!pointerActive)
                return;
            pointerActive = false;
            var dx = e.clientX - pointerStartX;
            var dy = e.clientY - pointerStartY;
            if (Math.abs(dx) < SWIPE_THRESHOLD)
                return;
            if (Math.abs(dy) > Math.abs(dx))
                return;
            if (dx < 0)
                goTo(current + 1);
            else
                goTo(current - 1);
            start();
        });
        rootEl.addEventListener("pointercancel", function () { pointerActive = false; });
        // Empêche le drag fantôme des images sur desktop pendant le swipe souris.
        $root.find("img").on("dragstart", function (e) { return e.preventDefault(); });
        // ----- Trackpad : swipe 2 doigts (wheel event horizontal) -----
        // On accumule deltaX sur une fenêtre courte ; au-delà du seuil, on
        // déclenche le slide. Reset après cooldown pour éviter le rebond.
        var wheelAccumulator = 0;
        var wheelCooldown = false;
        var WHEEL_THRESHOLD = 80;
        rootEl.addEventListener("wheel", function (e) {
            // Ne réagir qu'aux gestes horizontaux dominants
            if (Math.abs(e.deltaX) <= Math.abs(e.deltaY))
                return;
            if (wheelCooldown) {
                e.preventDefault();
                return;
            }
            e.preventDefault(); // empêche le scroll horizontal natif sur cette zone
            wheelAccumulator += e.deltaX;
            if (Math.abs(wheelAccumulator) >= WHEEL_THRESHOLD) {
                if (wheelAccumulator > 0)
                    goTo(current + 1);
                else
                    goTo(current - 1);
                wheelAccumulator = 0;
                wheelCooldown = true;
                window.setTimeout(function () { wheelCooldown = false; }, 600);
                start();
            }
        }, { passive: false });
        // Pause au hover désactivée : le slider tourne en continu même quand
        // l'utilisateur survole le bloc.
        start();
    });
    // ===== Card project — slideshow auto (fondu entre images de la galerie) =====
    $("[data-slideshow]").each(function (idx) {
        var $media = $(this);
        var $slides = $media.find(".card-project__slide");
        if ($slides.length < 2)
            return;
        var current = 0;
        // Stagger : décalage par card pour éviter le sync visuel
        var interval = 3500;
        var initialDelay = (idx * 250) % 1500;
        window.setTimeout(function () {
            window.setInterval(function () {
                var next = (current + 1) % $slides.length;
                var $nextSlide = $slides.eq(next);
                // Lazy-load la slide la première fois
                var lazyBg = $nextSlide.attr("data-bg");
                if (lazyBg) {
                    $nextSlide.css("background-image", "url('" + lazyBg + "')").removeAttr("data-bg");
                }
                $slides.removeClass("is-active");
                $nextSlide.addClass("is-active");
                current = next;
            }, interval);
        }, initialDelay);
    });
    // ===== Carousel Patrimoine — 3 visibles desktop, défilement 1 par 1 auto =====
    // Images collées (pas de gap), boucle infinie, pause au hover, aucune nav UI.
    $("[data-patrimoine-carousel]").each(function () {
        var $root = $(this);
        var $track = $root.find(".patrimoine-gallery__track");
        var $slides = $root.find(".patrimoine-gallery__slide");
        var total = $slides.length;
        if (total < 3)
            return;
        var interval = parseInt($root.attr("data-autoplay") || "4500", 10);
        var index = 0;
        var timer = null;
        var visibleCount = function () {
            var w = window.innerWidth;
            if (w <= 768)
                return 1;
            if (w <= 1024)
                return 2;
            return 3;
        };
        var goTo = function (i) {
            var _a;
            var visible = visibleCount();
            var maxStart = Math.max(0, total - visible);
            if (i > maxStart)
                i = 0;
            if (i < 0)
                i = maxStart;
            index = i;
            var slideW = (_a = $slides.first().outerWidth()) !== null && _a !== void 0 ? _a : 0;
            $track.css("transform", "translateX(-" + i * slideW + "px)");
        };
        var next = function () { return goTo(index + 1); };
        var start = function () { stop(); timer = window.setInterval(next, interval); };
        var stop = function () { if (timer) {
            window.clearInterval(timer);
            timer = null;
        } };
        $root.on("mouseenter", stop).on("mouseleave", start);
        var resizeTimer = null;
        $(window).on("resize", function () {
            if (resizeTimer)
                window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(function () { return goTo(index); }, 150);
        });
        start();
    });
    // ===== Newsletter single — toggle iframe Mailchimp lazy =====
    $("[data-newsletter-cta]").each(function () {
        var $root = $(this);
        var $btn = $root.find("[data-newsletter-toggle]");
        var $wrap = $root.find("[data-newsletter-iframe-wrap]");
        var src = $root.attr("data-iframe-src") || "";
        var injected = false;
        $btn.on("click", function () {
            if (!injected) {
                var iframe = document.createElement("iframe");
                iframe.src = src;
                iframe.loading = "lazy";
                iframe.title = "Newsletter Mailchimp";
                iframe.setAttribute("sandbox", "allow-same-origin allow-scripts allow-popups allow-forms");
                $wrap[0].appendChild(iframe);
                injected = true;
            }
            var open = !$wrap[0].hasAttribute("hidden") ? false : true;
            if (open)
                $wrap[0].removeAttribute("hidden");
            else
                $wrap[0].setAttribute("hidden", "");
            $btn.text(open
                ? $btn.data("label-hide") || "Masquer la version interactive"
                : $btn.data("label-show") || "Afficher la version interactive");
        });
    });
    // ===== Galerie projet — Lightbox GLightbox =====
    if (document.querySelector('[data-gallery="sp-gallery"]')) {
        GLightbox({
            selector: '[data-gallery="sp-gallery"]',
            touchNavigation: true,
            loop: true,
            autoplayVideos: false,
            // Pas de titre / description dans la lightbox.
            moreText: '',
            moreLength: 0,
            slideExtraAttributes: {
                title: ''
            }
        });
    }
});
